import React from 'react';
import {IClassNameProps} from '@bem-react/core';
import {cnCreateObjectOptions} from '../CreateObjectOptions';
import {CreateOptionGroup} from '../../CreateOptionGroup/CreateOptionGroup';
import {CreateOption} from '../../CreateOption/CreateOption';
import {CommonObjectHelper} from '../../../../3d/helpers/CommonObjectHelper/CommonObjectHelper';
import {ICreateObjectData} from '../../../../../common-code/interfaces/createData/ICreateObjectData';
import {KitchenService} from '../../../../3d/services/KitchenService/KitchenService';

export interface ICreateObjectOptionsListProps extends IClassNameProps {
    service: KitchenService;
    objectData: ICreateObjectData;
    createOptions: any;
    handleOptionChange: (fieldId: string, value: any, groupId?: string) => void;
}
export const CreateObjectOptionsList: React.FC<ICreateObjectOptionsListProps> =
    ({
         service,
         objectData,
         handleOptionChange,
         createOptions,
     }) => {
        return (
            <div className={cnCreateObjectOptions('Options')}>
                {objectData.options.map((option) => {
                    if ('isGroup' in option) {
                        return <CreateOptionGroup
                            key={option.id}
                            group={option}
                            onChange={handleOptionChange}
                            createOptions={createOptions}
                            disableSelects={objectData.disableSelects}
                            objectData={objectData}
                            service={service}
                        />;
                    } else {
                        return <CreateOption
                            key={option.id}
                            option={CommonObjectHelper.prepareCreateOption(
                                option,
                                objectData,
                                objectData.disableSelects ? objectData.disableSelects[option.id] : undefined
                            )}
                            type={option.type}
                            onChange={handleOptionChange}
                            createOptions={createOptions}
                            service={service}
                            objectData={objectData}
                        />;
                    }
                })}
            </div>
        );
    }